import { render, staticRenderFns } from "./CarouselHorizontal.vue?vue&type=template&id=3e776cff&"
import script from "./CarouselHorizontal.vue?vue&type=script&lang=js&"
export * from "./CarouselHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./CarouselHorizontal.vue?vue&type=style&index=0&id=3e776cff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports